module.exports = __webpack_public_path__ + "static/media/stethoscope.028c3ab5.svg";